import { LimitTypography } from '@aibees/elephant/components/limit-typography';
import { classnames } from '@aibees/shared/utils';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { memo } from 'react';
import { formattedStartToEndDuration } from '../../../../utils';
import * as SX from './sx';
import type { ProjectsItemProps as Props } from './types';

export const ProjectsItem = memo(({ className, item, index }: Props) => {
  return (
    <Card
      className={classnames('ProjectsItem', className)}
      sx={SX.root}
      key={index}
      variant="filled"
      color="default"
    >
      <CardContent padding="extra">
        <Box display="flex" flexDirection="column" gap={0.25}>
          <Box display="flex" flexDirection="column">
            <Typography variant="h6">{item.title}</Typography>
            {item.date?.start && (
              <Typography variant="body4" color="grey.500">
                {formattedStartToEndDuration(item.date.start, item.date?.end)}
              </Typography>
            )}
          </Box>
          <Box>
            <LimitTypography
              value={item.description || ''}
              wordLimit={25}
              variant="body4"
              color="grey.600"
              buttonSX={{
                fontSize: (p) => p.typography.caption.fontSize,
                fontWeight: 700,
              }}
            />
          </Box>

          {/* TODO we don't have the link to the project in the API data for now */}
          {/* {item.project && (
            <Button
              sx={SX.button}
              variant="outlined"
              size="small"
              onClick={handleClick}
            >
              Show Project
              <Icon
                name="link-out"
                size={12}
                color={theme.palette.primary[200]}
              />
            </Button>
          )} */}
        </Box>
      </CardContent>
    </Card>
  );
});

ProjectsItem.displayName = 'ProjectsItem';
